import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f5c1486"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loby-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loby-logo" }, null, -1))
const _hoisted_4 = { class: "info user-name" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "info user-coin" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = {
  key: 0,
  class: "tab-menu"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-btns" }, "小费", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "功能", -1))
const _hoisted_12 = { class: "content-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "content"
}
const _hoisted_14 = {
  key: 0,
  class: "multi-select-footer-info"
}
const _hoisted_15 = ["data-info"]
const _hoisted_16 = {
  key: 0,
  class: "content multi"
}
const _hoisted_17 = { class: "multi-table-betting" }
const _hoisted_18 = { class: "multi-item-group" }
const _hoisted_19 = { class: "chips-group-control" }
const _hoisted_20 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user_l = _resolveComponent("i-user-l")!
  const _component_i_balance = _resolveComponent("i-balance")!
  const _component_ctrl_dropdown = _resolveComponent("ctrl-dropdown")!
  const _component_i_balance_g = _resolveComponent("i-balance-g")!
  const _component_i_one_bar = _resolveComponent("i-one-bar")!
  const _component_i_two_bar = _resolveComponent("i-two-bar")!
  const _component_i_full = _resolveComponent("i-full")!
  const _component_i_normal = _resolveComponent("i-normal")!
  const _component_i_arrow_h = _resolveComponent("i-arrow-h")!
  const _component_list_item = _resolveComponent("list-item")!
  const _component_multi_table_item = _resolveComponent("multi-table-item")!
  const _component_ctrl_chips = _resolveComponent("ctrl-chips")!
  const _component_marquee_text = _resolveComponent("marquee-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_i_user_l, { class: "icon user-l" }),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_balance, { class: "icon balance" }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.coin), 1)
      ]),
      (!_ctx.isFreeUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 0 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDeskFilter(0)))
            }, " 全部 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 1 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDeskFilter(1)))
            }, " 百家乐 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 2 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeDeskFilter(2)))
            }, " 龙虎 ", 2),
            (_ctx.commandType === 2)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tab-item btn", { active: _ctx.tabId === 3 }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeDeskFilter(3)))
                }, " 多台 ", 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_9,
      (!_ctx.isFreeUser && _ctx.tabId !== 3)
        ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
            key: 1,
            class: "drop-down-game-type",
            listData: _ctx.gameOptionArray,
            labelName: 'typeName',
            modelValue: _ctx.gameOption,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.gameOption) = $event))
          }, null, 8, ["listData", "modelValue"]))
        : _createCommentVNode("", true),
      (!_ctx.isFreeUser && _ctx.tabId !== 3)
        ? (_openBlock(), _createBlock(_component_ctrl_dropdown, {
            key: 2,
            class: "drop-down-game-limit",
            listData: _ctx.limitOptionArray,
            modelValue: _ctx.limitOption,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.limitOption) = $event))
          }, null, 8, ["listData", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (
                        _ctx.tabId === 3 &&
                        _ctx.isMultitbableView &&
                        _ctx.getMultitableIds() !== ''
                    )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-ss",
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showTipBox && _ctx.showTipBox(...args)), ["prevent"]))
              }, [
                _createVNode(_component_i_balance_g, { class: "icon-btns" }),
                _hoisted_10
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_i_one_bar, {
        class: _normalizeClass(["icon one-bar", { active: _ctx.listDisplayType === 0 }]),
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(0)), ["prevent"]))
      }, null, 8, ["class"]),
      _createVNode(_component_i_two_bar, {
        class: _normalizeClass(["icon two-bar", { active: _ctx.listDisplayType === 1 }]),
        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.onChangeListDisplayType(1)), ["prevent"]))
      }, null, 8, ["class"]),
      (!_ctx.isfullScreen && _ctx.fullScreenAvailable)
        ? (_openBlock(), _createBlock(_component_i_full, {
            key: 3,
            class: "icon full",
            onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
          }, null, 8, ["onClick"]))
        : (_ctx.isfullScreen && _ctx.fullScreenAvailable)
          ? (_openBlock(), _createBlock(_component_i_normal, {
              key: 4,
              class: "icon normal",
              onClick: _withModifiers(_ctx.requestFullScreen, ["prevent"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "drop-down-setting",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showSettingDialog && _ctx.showSettingDialog(...args)))
      }, [
        _hoisted_11,
        _createVNode(_component_i_arrow_h, { class: "icon-arrow" })
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_Transition, { name: "slide-down" }, {
        default: _withCtx(() => [
          (!_ctx.isMultitbableView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(), _createElementBlock("div", {
                  class: "content-list",
                  key: _ctx.listKey
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDesk, (desk) => {
                    return (_openBlock(), _createBlock(_component_list_item, {
                      class: _normalizeClass(["content-list-item", {
                                'grid-3': _ctx.listDisplayType === 1,
                                'selected':
                                    _ctx.tabId === 3 &&
                                    _ctx.multiTableSelected.indexOf(desk.id) !== -1
                            }]),
                      key: desk.id,
                      mData: desk,
                      activeDesk: _ctx.currentDeskNo,
                      displayType: _ctx.listDisplayType,
                      onClick: ($event: any) => (_ctx.handleSelectDesk(desk.id, desk))
                    }, null, 8, ["class", "mData", "activeDesk", "displayType", "onClick"]))
                  }), 128))
                ])),
                (!_ctx.isMultitbableView && _ctx.tabId === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", {
                        class: "start-multi-betting",
                        "data-info": _ctx.multiTableSelectTip(),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.gotoMultitableView()))
                      }, " 开始多台投注 ", 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "slide-up" }, {
        default: _withCtx(() => [
          (_ctx.isMultitbableView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk1,
                      position: 0,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk2,
                      position: 1,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk3,
                      position: 2,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"]),
                    _createVNode(_component_multi_table_item, {
                      class: "multi-item",
                      desk: _ctx.desk4,
                      position: 3,
                      onRemove: _ctx.removeFromMultitable,
                      onSelectTable: _ctx.selecMultitables,
                      onStopBetting: _ctx.stopBetMultitable
                    }, null, 8, ["desk", "onRemove", "onSelectTable", "onStopBetting"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ctrl_chips, { class: "chips-group" })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      (_openBlock(), _createBlock(_component_marquee_text, {
        class: "m-notice",
        speed: 30,
        key: _ctx.noticeKey
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.lobyNotice), 1)
        ]),
        _: 1
      }))
    ])
  ]))
}